import React from "react";
import { Navigate } from "react-router-dom";

const WithTokenRedirect = ({ children }) => {
  const token = localStorage.getItem("userToken");

  // ✅ If token exists, redirect to /dashboard
  if (token && token.trim() !== "") {
    return <Navigate to="/export" replace />;
  }

  // 🚪 If no token, allow access to public routes like /login
  return <>{children}</>;
};

export default WithTokenRedirect;
